import { render, staticRenderFns } from "./UnsavedChangesEcommerce.vue?vue&type=template&id=4ccc6ac0&scoped=true&"
import script from "./UnsavedChangesEcommerce.vue?vue&type=script&lang=js&"
export * from "./UnsavedChangesEcommerce.vue?vue&type=script&lang=js&"
import style0 from "./UnsavedChangesEcommerce.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UnsavedChangesEcommerce.vue?vue&type=style&index=1&id=4ccc6ac0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccc6ac0",
  null
  
)

export default component.exports